import { Link } from 'react-router-dom';
import type { TvSeries } from '@/mocks/tvSeries';

interface TvCardProps {
  series: TvSeries;
}

export default function TvCard({ series }: TvCardProps) {
  return (
    <Link
      to={`/article/${series.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={series.coverImage}
          alt={`${series.title} - 四虎影视大全电视剧`}
          title={`${series.title} 电视剧全集在线观看 - 四虎影视大全`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
          {series.rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="inline-block text-xs text-background-50 bg-accent-500/80 px-2 py-0.5 rounded-full mb-2">
            {series.status}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-heading font-bold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {series.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{series.year}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-500">{series.region}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-500">{series.totalEpisodes}集</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {series.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}